<template>
        <TextField
                :value="singleValue"
                @input="emitSingleValue($event)"
        ></TextField>
</template>

<script>
  import TextField from "./components/TextField";
  import responseMixin from "./responseMixin";
  export default {
    name: "TextResponse",
    mixins: [responseMixin],
    components:{
            TextField
    },
    computed: {

    }
  }
</script>

<style scoped>

</style>